module.exports = __webpack_public_path__ + "img/co2_red.a303317b.svg";